import axios from 'axios';
import baseService from '../shared/baseService';
import { NewsStatus } from '../Features/Classification/enum/NewsStatus';

const CampaignService = (spreadsheetId: number) =>
    baseService(`campaign/${spreadsheetId}`);

const getCampaignByClient = (clientId: number,params?: Record<string, any>) =>
    axios.get(`campaign/${clientId}/client`, { params });

const getCampaignById = (campaignId: number,params?: Record<string, any>) =>
    axios.get(`campaign/${campaignId}/profile`, { params });

const deleteCampaignById = (clientId: number,params?: Record<string, any>) =>
    axios.delete(`campaign/${clientId}/delete`, { params });

const putClassificationCampaign = (clientId: number, params: any) => axios.put(`campaign/${clientId}/classification`, params);

const putRevisorCampaign = (clientId: number, params: any) => axios.put(`campaign/${clientId}/revisor`, params);

export default {
    CampaignService,
    getCampaignByClient,
    getCampaignById,
    putRevisorCampaign,
    putClassificationCampaign,
    deleteCampaignById,
};